<template>
  <div class="coupon-dia">
    <van-popup v-model="showCouponPopup" position="bottom" @close="close" v-if="validCouponListSort">
      <div class="title">{{ $t('lang.giftSign.coupon') }}</div>
      <van-tabs v-model="active" swipeable>
        <van-tab
          v-for="tabOption in tebTit"
          :title="tabOption.id == 0 ? `${tabOption.tit0}(${validCouponListSort.length})` : `${tabOption.tit1}(${expiredCouponList.length})`"
          :key="tabOption.id"
        >
          <!-- 有效优惠券 -->
          <div v-if="tabOption.id == 0" class="tab tab1">
            <div class="coupon" v-for="(item, index) in validCouponListSort" :key="index" @click="chooseCoupon(item, index)">
              <div class="left">
                <div class="dis-text">
                  <div class="extra-tip">
                    <p class="text-extra">
                      <i>{{ item.amount }}</i>
                      {{ $t('lang.coupon.extra') }}
                    </p>
                    <!-- prettier-ignore -->
                    <p class="text-tip">
                      {{ $t('lang.coupon.desc1') }} <i>{{ item.minUseAmount }}<img :src="getMatchImg('coin')" /></i>{{ $t('lang.coupon.desc2') }}
                    </p>
                  </div>
                  <span class="text-time">Expires: {{ handleTime9(item.expiredTime) }}</span>
                  <div class="left-circle"></div>
                  <div class="right-circle"></div>
                </div>
              </div>
              <div class="right">
                <div class="coupon-num">
                  <div class="radio-checked">Use</div>
                </div>
              </div>
            </div>
            <div class="no-coupons" v-if="validCouponListSort.length == 0">{{ $t('lang.intimate.noCouponTip') }}</div>
          </div>

          <!-- 过期优惠券 -->
          <div v-if="tabOption.id == 1" class="tab tab2">
            <div class="coupon expired-coupon" v-for="(item, index) in expiredCouponList" :key="index">
              <div class="left">
                <div class="dis-text">
                  <div class="extra-tip">
                    <p class="text-extra">
                      <i>{{ item.amount }}</i>
                      {{ $t('lang.coupon.extra') }}
                    </p>
                    <!-- prettier-ignore -->
                    <p class="text-tip">
                      {{ $t('lang.coupon.desc1') }} <i>{{ item.minUseAmount }} <img :src="getMatchImg('coin')" /></i>{{ $t('lang.coupon.desc2') }}
                    </p>
                  </div>
                  <span class="text-time">Expires: {{ handleTime9(item.expiredTime) }}</span>
                  <div class="left-circle"></div>
                  <div class="right-circle"></div>
                </div>
              </div>
              <div class="right">
                <div class="coupon-num">
                  <div class="expired">{{ $t('lang.intimate.expired') }}</div>
                </div>
              </div>
            </div>
            <div class="no-coupons" v-if="expiredCouponList.length == 0">{{ $t('lang.intimate.noCouponTip') }}</div>
          </div>
        </van-tab>
      </van-tabs>
      <div class="confirm-btn" :class="{ 'no-click': (active == 0 && (validCouponListSort.length == 0 || this.chooseCouponId == null)) || active == 1 }" @click="handleConfirm">
        {{ $t('lang.confirm') }}
      </div>
      <div :style="{ width: '100%', height: `${bottomBarHeight}px` }"></div>
    </van-popup>
  </div>
</template>

<script>
// store 优惠卷
export default {
  props: {
    active: {
      default: 0
    },
    showCouponPopup: {},
    tebTit: {},
    validCouponListSort: {}, // 排序之后有效的优惠劵
    maxCoupon: {}, // 最大的优惠劵
    expiredCouponList: {} // 无效的优惠劵,
  },
  data() {
    return {
      chooseCouponId: null,
      chooseCouponOption: {}
    }
  },
  methods: {
    close() {
      this.$emit('close', false)
    },

    // 选中优惠卷
    chooseCoupon(item) {
      this.chooseCouponOption = item
      this.chooseCouponId = item.couponRecordId
    },

    // 确定选中
    handleConfirm() {
      if (this.chooseCouponId) {
        if (this.chooseCouponOption) {
          this.$emit('confirmChooseCouponId', this.chooseCouponOption)
        } else {
          this.$emit('confirmChooseCouponId', this.maxCoupon)
        }
      } else {
        this.close()
      }
    }
  },
  watch: {
    maxCoupon: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.couponRecordId) {
          this.chooseCouponId = newVal.couponRecordId
        }
      }
    },
    validCouponListSort: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.maxCoupon = this.validCouponListSort[0] || null
          this.$forceUpdate()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.coupon-dia {
  font-family: Inter;
  .van-popup {
    width: 100%;
    min-height: 432px;
    padding: 20px 24px;
    overflow: hidden;
  }
  .title {
    width: 100%;
    height: 20px;
    font-weight: bold;
    font-size: 17px;
    color: #333333;
    line-height: 20px;
    text-align: center;
  }
  .tab {
    height: 260px;
    overflow-y: auto !important;
    color: #333333;
  }

  .coupon {
    width: 100%;
    height: 112px;
    margin-bottom: 12px;
  }

  .expired-coupon {
    filter: grayscale(1);
    pointer-events: none;
  }

  .coupon,
  .expired-coupon {
    display: flex;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 2px 2px 4px rgba(75, 34, 0, 0.05);
    position: relative;
    .left {
      flex: 1;
      display: flex;
      align-items: center;
      // .coupon-head {
      //   width: 44px;
      //   height: 100%;
      //   background: url(./images/ch-on-joychat.png) top left / auto 100% no-repeat;
      //   display: flex;
      //   align-items: center;
      //   justify-content: center;
      // }
      .left-num {
        width: 90px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .money-icon {
          width: 36px;
          height: 36px;
        }
        .money-num {
          margin-bottom: 10px;
          font-weight: bold;
          font-size: 20px;
          color: #ff483c;
          line-height: 24px;
        }
      }
      .dis-text {
        width: 100%;
        height: 100%;
        border-radius: 12px;
        background-color: #fff18d;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        position: relative;
        .extra-tip {
          width: 100%;
          flex: 1;
          padding: 8px 24px;
          .text-extra {
            color: #ff5654;
            font-family: Inter-Regular;
            font-size: 22px;
            line-height: 27px;
            font-weight: bold;
            i {
              color: #ff5654;
              font-family: Barlow;
              font-size: 28px;
              font-style: italic;
              font-weight: bold;
              line-height: 35px;
            }
          }
          .text-tip {
            color: #545455;
            font-family: Inter-Regular;
            font-size: 12px;
            font-weight: 500;
            margin-top: 8px;
            i {
              color: #000000;
              font-family: Barlow;
              font-size: 14px;
              font-weight: 500;
              line-height: 17.5px;
              > img {
                width: 12px;
                height: 12px;
                vertical-align: middle;
                margin: 0 2px;
              }
            }
          }
        }

        .text-time {
          width: 100%;
          padding: 4px 10px;
          background: #fffce6;
          display: flex;
          align-items: center;
          justify-content: center;

          color: #878788;
          text-align: center;
          font-family: Inter-Regular;
          font-size: 12px;
        }

        .left-circle,
        .right-circle {
          width: 24px;
          height: 24px;
          border-radius: 12px;
          background-color: #f8f8f8;
          position: absolute;
          top: 50%;
          margin-top: -12px;
        }
        .left-circle {
          left: -12px;
        }
        .right-circle {
          right: -12px;
        }
      }
    }

    .right {
      position: absolute;
      right: 24px;
      top: 22px;
      .coupon-num {
        .radio {
          width: 28px;
          height: 28px;
          background: url(./images/uncheck-icon.png) center / 100% no-repeat;
          border-radius: 50%;
        }
        .radio-checked {
          display: flex;
          height: 32px;
          padding: 0 16px;
          justify-content: center;
          align-items: center;
          border-radius: 60px;
          background: #ff8a33;
          color: #ffffff;
          font-family: Inter-Regular;
          font-size: 14px;
          font-weight: 500;
        }
        .expired {
          display: flex;
          height: 32px;
          padding: 0 16px;
          justify-content: center;
          align-items: center;
          border-radius: 60px;
          background: #eaedf2;
          color: #878788;
          font-family: Inter-Regular;
          font-size: 14px;
          font-weight: 500;
        }
      }
    }
  }

  .confirm-btn {
    width: 289px;
    height: 40px;
    margin: 17px auto 0;
    background: #ffe242;
    border-radius: 20px;
    font-family: Inter;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
    line-height: 40px;
    text-align: center;
  }

  .no-click {
    pointer-events: none;
    background: #e1e1e1;
  }

  .no-coupons {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Inter;
    font-weight: 400;
    font-size: 17px;
    color: #999999;
    line-height: 20px;
  }
}
html[lang='ar'] {
  .coupon-dia .coupon .right,
  .coupon-dia .expired-coupon .right {
    right: unset;
    left: 24px;
  }
}
</style>

<style lang="scss">
.coupon-dia {
  .van-popup {
    background-color: #f8f8f8;
  }
  .van-tabs__nav {
    background-color: #f8f8f8 !important;
  }
}
</style>

<style lang="scss" scoped>
::v-deep .van-tab {
  font-size: 15px;
  color: #999999;
}
::v-deep .van-tab--active {
  color: #333333;
  font-weight: 600;
}
::v-deep .van-tabs__line {
  display: none;
}

// 去掉滚动条
::-webkit-scrollbar {
  display: none;
}
::-webkit-scrollbar-track {
  display: none;
}
</style>
